const genStepsProgressStyle = token => {
  const {
    antCls,
    componentCls
  } = token;
  return {
    ["&".concat(componentCls, "-with-progress")]: {
      ["".concat(componentCls, "-item")]: {
        paddingTop: token.paddingXXS,
        ["&-process ".concat(componentCls, "-item-container ").concat(componentCls, "-item-icon ").concat(componentCls, "-icon")]: {
          color: token.processIconColor
        }
      },
      ["&".concat(componentCls, "-vertical > ").concat(componentCls, "-item ")]: {
        paddingInlineStart: token.paddingXXS,
        ["> ".concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail")]: {
          top: token.marginXXS,
          insetInlineStart: token.calc(token.iconSize).div(2).sub(token.lineWidth).add(token.paddingXXS).equal()
        }
      },
      ["&, &".concat(componentCls, "-small")]: {
        ["&".concat(componentCls, "-horizontal ").concat(componentCls, "-item:first-child")]: {
          paddingBottom: token.paddingXXS,
          paddingInlineStart: token.paddingXXS
        }
      },
      ["&".concat(componentCls, "-small").concat(componentCls, "-vertical > ").concat(componentCls, "-item > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail")]: {
        insetInlineStart: token.calc(token.iconSizeSM).div(2).sub(token.lineWidth).add(token.paddingXXS).equal()
      },
      ["&".concat(componentCls, "-label-vertical")]: {
        ["".concat(componentCls, "-item ").concat(componentCls, "-item-tail")]: {
          top: token.calc(token.margin).sub(token.calc(token.lineWidth).mul(2).equal()).equal()
        }
      },
      ["".concat(componentCls, "-item-icon")]: {
        position: 'relative',
        ["".concat(antCls, "-progress")]: {
          position: 'absolute',
          insetBlockStart: token.calc(token.calc(token.iconSize).sub(token.stepsProgressSize).sub(token.calc(token.lineWidth).mul(2).equal()).equal()).div(2).equal(),
          insetInlineStart: token.calc(token.calc(token.iconSize).sub(token.stepsProgressSize).sub(token.calc(token.lineWidth).mul(2).equal()).equal()).div(2).equal()
        }
      }
    }
  };
};
export default genStepsProgressStyle;